module.exports = __webpack_public_path__ + "img/19.55436095.jpg";